import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccountLayout } from "../AccountLayout";
import { NSSection, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { NSPanel } from 'namirasoft-site-react';

interface UserBannedPageProps extends NSARouterMakerResult
{ }

function UserBannedPage(props: UserBannedPageProps) 
{
    return (
        <AccountLayout {...props}
            title={{
                title: 'Banned Account',
                description: `Your account has been banned due to violations of our Terms of Service and you cannot log in to your account. <br />
					For more information, contact our support team.`
            }}
        >
            <NSSection>
                <NSPanel>
                    <img src="https://static.namirasoft.com/image/concept/error/red.svg" alt="error" width={128} height={128} />
                    <NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>
                    <h4 className={"nsa-color-blue-dark nsa-font-24-bold mb-0 nsa-center"}>Your account has been Banned</h4>
                    <NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>
                    <a className={`nsa-font-16-normal nsa-color-blue-dark`} href="https://namirasoft.com/account/terms/">
                        Terms of Condition
                    </a>
                </NSPanel>
            </NSSection>
        </AccountLayout>
    );
}

export default UserBannedPage;